export { ExcelExportModule } from "./excelExportModule";
export { getMultipleSheetsAsExcel, exportMultipleSheetsAsExcel } from './excelExport/excelCreator';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-enterprise/excel-export/dist/es6/main.js
// module id = 1164
// module chunks = 0